export const ROUTE_CONFIG = {
  NO_LAYOUT_ROUTES: ['/login', '/forgot-password', '/onboard', '/learning-intelligence']
};
export const shouldHideNavigation = (pathname: string): boolean => {
  return ROUTE_CONFIG.NO_LAYOUT_ROUTES.includes(pathname);
};
